import { createRoot } from "react-dom/client";
import App from "../../map/app";

const container = document.getElementById("leaflet-map");
if (container) {
  const root = createRoot(container);
  root.render(<App className="h-[inherit] z-[inherit]" showDetours showPois />);
}
